const authenticationTypes = {
	LOGIN_BY_EMAIL: {
		REQUEST: 'LOGIN_BY_EMAIL_REQUEST',
	},
	LOGIN_BY_OTP: {
		REQUEST: 'LOGIN_BY_OTP_REQUEST',
		SUCCESS: 'LOGIN_BY_OTP_SUCCESS',
		FAILURE: 'LOGIN_BY_OTP_FAILURE',
	},
	LOGIN_BY_ID: {
		REQUEST: 'LOGIN_BY_ID_REQUEST',
		SUCCESS: 'LOGIN_BY_ID_SUCCESS',
		FAILURE: 'LOGIN_BY_ID_FAILURE',
	},
	CHECK_OTP: {
		REQUEST: 'CHECK_OTP_REQUEST',
	},
	SESSION_CHECK: {
		REQUEST: 'SESSION_CHECK_REQUEST',
	},
	LOGIN: {
		SUCCESS: 'LOGIN_SUCCESS',
		FAILURE: 'LOGIN_FAILURE',
	},
	GET_SESSIONS: {
		REQUEST: 'GET_SESSIONS_REQUEST',
		SUCCESS: 'GET_SESSIONS_SUCCESS',
		FAILURE: 'GET_SESSIONS_FAILURE',
	},
	LOGOUT: {
		REQUEST: 'LOGOUT_REQUEST',
		SUCCESS: 'LOGOUT_SUCCESS',
	},
	APP_INIT: {
		REQUEST: 'APP_INIT_REQUEST',
		SUCCESS: 'APP_INIT_SUCCESS',
	},
};

export default authenticationTypes;
